/**
 * Copyright 2025 Google LLC. This software is provided as-is, without warranty 
 * or representation for any use or purpose. Your use of it is subject to your 
 * agreement with Google.
 */
import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { OktaAuthGuard, OktaCallbackComponent } from '@okta/okta-angular';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { SafeNavigationGuard } from './guards/safe-navigation.guard';

export const routes: Routes = [
  { path: '', component: HomeComponent, canActivate: [OktaAuthGuard] },
  { path: 'unauthorized', component: UnauthorizedComponent , canActivate: [SafeNavigationGuard] },
  { path: 'login/callback', component: OktaCallbackComponent },
];